import useDynamicPage from "../../hooks/useDynamicPage";
import useDynamicPages from "../../hooks/useDynamicPages";
import { DynamicPageSeo } from "../../ui/DynamicPageSeo";
import { BuilderContentBlocks } from "../../ui/BuilderContentBlocks";

export default function GenericPages({ prefix, title, seo, canonical, data }) {
  return (
    <>
      <DynamicPageSeo
        {...seo}
        title={seo?.title.length > 0 ? seo.title : title}
        canonical={seo?.canonical.length > 0 ? seo.canonical : canonical}
      />
      <BuilderContentBlocks data={data} prefix={prefix} />
    </>
  );
}

export async function getStaticProps({ params: { url_slugs } }) {
  const url_slug = url_slugs.join("/");
  const page = useDynamicPage(url_slug);

  if (page?.is_draft === true) {
    return { notFound: true };
  }

  return {
    props: {
      isBuilder: true,
      prefix: `page_${url_slug.replaceAll(/[\/\-]/g, "_")}`,
      title: page.title,
      seo: page.seo,
      canonical: `/${url_slug}`,
      data: page.content,
    },
  };
}

export async function getStaticPaths() {
  const pages = useDynamicPages();
  const exclude = [];
  const paths = pages
    .filter((i) => !exclude.includes(i.url_slug))
    .map((i) => ({ params: { url_slugs: i.url_slug.split("/") } }));

  return {
    paths,
    fallback: false,
  };
}